export default __webpack_public_path__ + "static/media/order-picked.6ac6d44e.png";